import type { AxiosRequestConfig } from "axios";

export const getCachePlatform = (): "FTX" | "PTX" => {
    const flavor = process.env.REACT_APP_FLAVOR;
    if (flavor === "peterpans") return "PTX";
    if (flavor === "freelance") return "FTX";
    throw new Error(`Invalid REACT_APP_FLAVOR: "${flavor}". Must be either "peterpans" or "freelance".`);
};

/** Shared cache routes select brand explicitly; JWT identity does not select it. */
export const applyCacheRequestBrand = <T extends AxiosRequestConfig>(config: T): T => {
    if (!config.url?.startsWith("/cache/")) return config;
    const baseUrl = process.env.REACT_APP_API_URL_V2 || "";
    const parts = baseUrl.split("/api/");
    config.baseURL = parts.length > 1 ? `${parts[0]}/api` : baseUrl;
    const platform = getCachePlatform();
    if (config.params instanceof URLSearchParams) {
        config.params = new URLSearchParams(config.params);
        config.params.set("platform", platform);
    } else {
        config.params = { ...config.params, platform };
    }
    // Avoid conflicting selectors if a caller embedded platform in the URL.
    const [path, query] = config.url.split("?");
    if (query) {
        const params = new URLSearchParams(query);
        params.delete("platform");
        const remaining = params.toString();
        config.url = path + (remaining ? `?${remaining}` : "");
    }
    return config;
};
